import React from 'react'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { formatCurrencyShort } from '../../../utils/functions'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const SpendChart = ({ data }) => {
  // If no data is provided, return null
  if (!data) return null

  const { labels, datasets } = data.data

  const chartData = {
    labels: labels,
    datasets: datasets.map((dataset) => ({
      ...dataset,
      barThickness: 17,
      borderRadius: 8,
      barPercentage: 0.4,
      categoryPercentage: 0.7,
    })),
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: '#fff',
        titleFont: { size: 14, weight: 'bold', family: 'Arial', color: '#000' },
        bodyFont: { size: 12, family: 'Arial', color: '#000' },
        padding: 10,
        displayColors: true,
        borderWidth: 1,
        borderColor: '#ddd',
        cornerRadius: 6,
        titleColor: '#000',
        bodyColor: '#000',
        callbacks: {
          title: (tooltipItems) => `Month: ${tooltipItems[0].label}`,
          label: (tooltipItem) => {
            return `${tooltipItem.dataset.label}: NGN ${
              tooltipItem.raw?.toLocaleString() || '0'
            }`
          },
        },
      },
      legend: {
        position: 'bottom',
        align: 'end',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 10,
          color: '#000',
        },
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        ticks: {
          callback: function (value) {
            return formatCurrencyShort(value)
          },
          color: '#000',
        },
      },
    },
  }

  return (
    <div className='flex h-full'>
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default SpendChart